//@ts-nocheck

import { CircularProgress } from "@mui/material";
import React from "react";

function Loading({ height = "100vh" }) {
  return (
    <div style={{ height: height }} data-testid="loading-component" className={`w-full flex items-center justify-center`}>
      <CircularProgress sx={{ color: "#faaf19" }} />
    </div>
  );
}

export default Loading;
